<template>
<div>
    <div class="head-container">
        <HeadDetailsGama
        :btnSolicitacoes="selectedSolicitacao.status == 2 || selectedSolicitacao.status == 3"
        @cancelarSolicitacao="$emit('cancelarSolicitacao')"
        :btnPendencyApproveRequest="selectedSolicitacao.status == 4"
        :titleHead="'Detalhes do Cliente'">
        </HeadDetailsGama>
        <ModalRequest :selectedSolicitacao="selectedSolicitacao" :id="selectedSolicitacao.id" :request="selectedSolicitacao" ></ModalRequest>
    </div>

    <div id="body-details" class="mt-4 ml-2">
        <p  class="ml-3 subtitle">Dados do Cliente</p>
        <div class="d-flex flex-wrap">
            <div class="col-md-6">
                <p class="label-details">Nome</p>
                <input class="input-details" disabled v-model="selectedSolicitacao.cliente.nome">
            </div>
            <div class="col-md-6">
                <p class="label-details">E-mail</p>
                <input disabled class="input-details" v-model="selectedSolicitacao.cliente.email">
            </div>
            <div class="col-md-3 mt-4">
                <p class="label-details">CPF</p>
                <input class="input-details" disabled v-model="selectedSolicitacao.cliente.cpf">
            </div>
            <div class="col-md-3 mt-4">
                <p class="label-details">RG</p>
                <input disabled class="input-details" v-model="selectedSolicitacao.cliente.rg">
            </div>
            <div class="col-md-3 mt-4">
                    <p class="label-details">Celular</p>
                    <input class="input-details" disabled v-model="selectedSolicitacao.cliente.celular">
            </div>
             <div class="col-md-3 mt-4">
                <p class="label-details">Data de Nascimento</p>
                <b-form-datepicker
                disabled
                v-model="selectedSolicitacao.cliente.dataNascimento"
                class="input-details"
                placeholder="__/__/____"
                locale="pt-BR"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
            </div>

        </div>

        <p  class="ml-3 pt-4 subtitle">Endereço</p>
        <div class="d-flex flex-wrap">
            <div class="col-md-4">
                    <p class="label-details">CEP</p>
                    <input class="input-details" disabled v-model="selectedSolicitacao.cliente.cep">
            </div>
            <div class="col-md-4">
                    <p class="label-details">Cidade</p>
                    <input class="input-details" disabled v-model="selectedSolicitacao.cliente.cidade">
            </div>
            <div class="col-md-4">
                    <p class="label-details">Endereço</p>
                    <input class="input-details" disabled v-model="selectedSolicitacao.cliente.endereco">
            </div>
        </div>
        <div class="d-flex flex-wrap">
            <div class="col-md-4 mt-4">
                <p class="label-details">Bairro</p>
                <input class="input-details" disabled v-model="selectedSolicitacao.cliente.bairro">
            </div>
            <div class="col-md-2 mt-4">
                <p class="label-details">Número</p>
                <input class="input-details" disabled v-model="selectedSolicitacao.cliente.numero">
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ClientDetails from './clientDetails'
export default ClientDetails
</script>

<style scoped>

    .subtitle{
        font-size: 18px;
        color: #008148;
        font-weight: bold;
        margin-bottom: 15px;
    }

    .input-details{
        width: 100%;
        height: 35px;
        padding-left: 0.5rem;
        background-color: #F1F1F1;
        border: 1px solid #D4D9DE;
        border-radius: 5px;
    }

    .head-container{
        display: flex;
        justify-content: space-between;
    }

    .form-control {
        background-color: #F1F1F1 !important;
    }

    .label-details {
        margin: 0;
        padding: 0 0 0.5rem 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/requests/components/clientDetails/clientDetails.vue